import React, { useState } from 'react';

import { Button, Header } from 'semantic-ui-react';

import ConfirmModal from 'components/common/ConfirmModal';

import { useFaqsPageTabContext } from '../../context';
import FaqsPageGroupAssignment from '../FaqsPageGroupAssignment';

const propTypes = {};
const defaultProps = {};

export default function FaqsPageSuccess() {
  const [deleting, setDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { faqPage, onDeleteFaqsPage } = useFaqsPageTabContext();
  const slug = faqPage?.slug || '';

  async function onConfirmDelete() {
    setDeleting(true);
    try {
      await onDeleteFaqsPage();
      setShowDeleteModal(false);
    } finally {
      setDeleting(false);
    }
  }

  return (
    <div className="content-block">
      <Header as="h3">FAQs page is set up</Header>
      <p>
        Your FAQs page is live at <strong>/{slug}</strong>
      </p>

      <FaqsPageGroupAssignment />

      <div className="content-block-actions">
        <ConfirmModal
          trigger={
            <Button
              className="delete-red"
              size="small"
              content="Delete FAQs Page"
              icon="trash"
              loading={deleting}
              disabled={deleting}
              onClick={() => setShowDeleteModal(true)}
            />
          }
          open={showDeleteModal}
          header="Delete FAQs Page"
          content="Are you sure you want to delete the FAQs page? This action cannot be undone."
          confirmButton={<Button className="delete-red" content="Delete" />}
          cancelButton={<Button className="action-button-gray" content="Cancel" />}
          onCancel={() => setShowDeleteModal(false)}
          onConfirm={onConfirmDelete}
        />
      </div>
    </div>
  );
}

FaqsPageSuccess.propTypes = propTypes;
FaqsPageSuccess.defaultProps = defaultProps;
